import type { Feature, FeatureCollection } from 'geojson';

import { env } from '@/config/env';

/**
 * Chiến lược dữ liệu vùng ngập phân tích:
 * - **Mặc định:** `public/hanoi_flood_areas.geojson` (đa giác demo).
 * - **Ghi đè:** `VITE_FLOOD_REGION_GEOJSON_URLS` — một hoặc nhiều URL GeoJSON (phân tách dấu phẩy), ví dụ API/CDN.
 * - Độ sâu hiển thị theo năm: `getDepthScaleForYear` + thuộc tính GeoJSON (xem `floodExternalDataSources.ts`).
 */

/** Mặc định chỉ Hà Nội. Ghi đè toàn bộ bằng `env.FLOOD_REGION_GEOJSON_URLS`. */
export const DEFAULT_FLOOD_REGION_GEOJSON_URLS = ['/hanoi_flood_areas.geojson'] as const;

/** @deprecated Dùng {@link DEFAULT_FLOOD_REGION_GEOJSON_URLS} */
export const FLOOD_REGION_GEOJSON_URLS = DEFAULT_FLOOD_REGION_GEOJSON_URLS;

/**
 * Tải và gộp các FeatureCollection vùng ngập. Một URL lỗi/404 → bỏ qua, không gãy toàn bộ.
 */
export async function loadMergedFloodRegionGeoJson(
  signal?: AbortSignal,
): Promise<FeatureCollection> {
  const urls = env.FLOOD_REGION_GEOJSON_URLS ?? [...DEFAULT_FLOOD_REGION_GEOJSON_URLS];
  const chunks = await Promise.all(
    urls.map(async (url) => {
      try {
        const res = await fetch(url, { cache: 'no-store', signal });
        if (!res.ok) return [] as Feature[];
        const j = (await res.json()) as FeatureCollection;
        return Array.isArray(j?.features) ? j.features : [];
      } catch {
        return [] as Feature[];
      }
    }),
  );
  const features = chunks.flat();
  return { type: 'FeatureCollection', features };
}
